/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Header from '../Header'
import styles from './CurrentPlan.css'
import LoadingSpinner from 'components/LoadingSpinner'

class CurrentPlan extends Component {
  render () {
    let {currentSubscriptionPlanName, showLoadingSpinnerPage} = this.props
    let lastPaymentDate = this.props.last_payment_date
    return (
      <div>
        <Header title='current plan' />
        <div className={styles['loading-plan']}>
          <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
        </div>
        {!showLoadingSpinnerPage &&
          <div className={styles['mb-30px']}>
            <div className={styles['mb-10px']}>Your current subscription plan: <strong className={currentSubscriptionPlanName === 'Expired' ? styles['is-expired'] : ''}>{currentSubscriptionPlanName}</strong></div>
            <div>Last Payment: <strong>{lastPaymentDate ? moment(lastPaymentDate).format('DD MMMM YYYY') : 'N/A'}</strong>
            </div>
          </div>}
      </div>
    )
  }
}

function mapStateToProps (state) {
  const {currentSubscriptionPlanName} = state.setting.billing
  const {last_payment_date} = state.moka.user.business
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {last_payment_date, currentSubscriptionPlanName, showLoadingSpinnerPage}
}

export default connect(mapStateToProps)(CurrentPlan)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/CurrentPlan/CurrentPlan.js